import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  style: {"position":"relative"},
  class: "bg-white p-5 border border-gray-200 rounded-2xl dark:border-gray-800 lg:p-6"
}
const _hoisted_2 = { class: "grid grid-cols-3 gap-4 mb-8" }
const _hoisted_3 = { class: "col-span-3" }
const _hoisted_4 = { class: "grid grid-cols-8 gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-800 dark:text-white/90 flex justify-between items-center" }, " Invoice Comparision ", -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Vendor")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.vendor), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _cache[1] || (_cache[1] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Invoice Number")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.invoice_NaN), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _cache[2] || (_cache[2] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Project Number")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.project_NaN), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _cache[3] || (_cache[3] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Customer")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.customer), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _cache[4] || (_cache[4] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Project Manager")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.project_manager), 1 /* TEXT */)
      ]),
      _createElementVNode("div", null, [
        _cache[5] || (_cache[5] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Total")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.total), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { class: "mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400" }, [
          _createElementVNode("strong", null, "Project Description")
        ], -1 /* CACHED */)),
        _createTextVNode(" " + _toDisplayString($setup.props.invoice?.invoice_information.project_description), 1 /* TEXT */)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createStaticVNode("<div><strong>Part Name</strong></div><div><strong>Quantity</strong></div><div><strong>Unit Of Measure</strong></div><div><strong>Price per Unit</strong></div><div><strong>Line Item Total</strong></div><div><strong>PO Quantity</strong></div><div><strong>PO Price per Unit</strong></div><div><strong>PO Line Item Total</strong></div>", 8)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.invoice?.invoice_line_items, (line_item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString(line_item.part_name), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString(line_item.quantity), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString(line_item.unit_of_measure), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString($setup.display_currency(line_item.price_per_unit)), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString($setup.display_currency(line_item.line_item_total)), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString($setup.get_matching_po_item($setup.com_purchase_order_line_items, line_item)?.quantity), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString($setup.display_currency($setup.get_matching_po_item($setup.com_purchase_order_line_items, line_item)?.price_per_unit)), 3 /* TEXT, CLASS */)),
          (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass({ 'text-error': $setup.line_item_has_discrepancy($setup.com_purchase_order_line_items, line_item) }),
            key: line_item.part_name
          }, _toDisplayString($setup.display_currency($setup.get_matching_po_item($setup.com_purchase_order_line_items, line_item)?.line_item_total)), 3 /* TEXT, CLASS */))
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}